import { Grid, useMediaQuery } from "@cd2/components"
import React, { useState } from "react"

interface IRowContainerProps {
  children: React.ReactNode
  isDragging?: boolean
  hasErrors?: boolean
  color?: string
}

export function RowContainer({
  children,
  isDragging,
  hasErrors,
  color = "white",
}: IRowContainerProps) {
  const [focused, setFocused] = useState(false)
  const isNarrow = useMediaQuery({ maxWidth: 1260 })

  const style: React.CSSProperties = {
    userSelect: "none",
    boxShadow: isDragging ? "0 0 10px rgba(0,0,0,0.2)" : "0 0 0 rgba(0,0,0,0.2)",
    borderRadius: 8,
    overflow: isDragging ? "hidden" : "visible",
    transform: `rotate(${isDragging ? 2 : 0}deg)`,
    position: "relative",
    zIndex: focused ? 2 : 1,
    borderBottom: "1px solid #eee",
    padding: 8,
    background: hasErrors ? "#ffd8d8" : color,
  }

  return (
    <div onFocus={() => setFocused(true)} onBlur={() => setFocused(false)} style={style}>
      <Grid columns={[40, isNarrow ? "min-content" : "auto", 40]} gap={8} alignItems="start">
        {children}
      </Grid>
    </div>
  )
}
